import { GetRouteReqQuery, GetRouteRes } from "../../types/routeContract";
import Api from "../api";

export default async function apiGetRoute(query?: GetRouteReqQuery) {
  return await Api.get<GetRouteRes[]>({
    input: "/api/v1/route",
    query,
  });
}
